// The card fee on a wallet top-up — Stripe's 2.9% + 30¢ grossed up so the wallet is credited
// exactly the amount asked for. Mirrors Services/Fees/TopUpFees.cs; the server's number is what
// is charged, this one is only what the screen shows before the card is confirmed.
export const TOPUP_STRIPE_PERCENT = 2.9;
export const TOPUP_STRIPE_FLAT_CENTS = 30;

export function topUpFeeCents(amountCents) {
  if (!Number.isFinite(amountCents) || amountCents <= 0) return 0;
  const gross = Math.ceil((amountCents + TOPUP_STRIPE_FLAT_CENTS) / (1 - TOPUP_STRIPE_PERCENT / 100));
  return gross - amountCents;
}
